import api from 'service/api'

const dponetAPI = api.create('cookies', false)

const compile = async ({ bannerId }) =>
  await dponetAPI.post(`/banners/${bannerId}/age_gate/compile`)

const create = async ({ bannerId, ageGate }) =>
  await dponetAPI.post(`/banners/${bannerId}/age_gate`, { ageGate })

const destroy = async ({ bannerId }) =>
  await dponetAPI.delete(`/banners/${bannerId}/age_gate`)

const get = async ({ bannerId = '', ...params }) =>
  await dponetAPI.get(`/banners/${bannerId}/age_gate`, { params })

const update = async ({ bannerId = '', ageGate }) =>
  await dponetAPI.patch(`/banners/${bannerId}/age_gate`, { ageGate })

export default {
  compile,
  create,
  destroy,
  get,
  update,
}
